import { isInBrowser } from './isInBrowser';

// R.complement do not work
export const isInNodeEnvironment = () => !isInBrowser();
